// Константы шаблона
export const TEMPLATE_SIZE = {
  width: 1080,
  height: 1920,
};

// Границы безопасной зоны
export const TEMPLATE_BOUNDS = {
  // Медиа, второй заход (отзыв 04.09): «граница справа от плашки не
  // исправлена, нужно шире — во всех почти рилсах». 56/1024 всё ещё
  // складывали текст уже монтажёрского: у эталонов поля ~44 px.
  // ЗЕРКАЛО — backend src/shared/lib/video/video-utils.ts (копия для drawOverlay).
  left: 44,
  right: 1036,
  top: 240,
  bottom: 1920,
  // Правый вырез нейтрализован (отзыв 04.09: «убери уголок»): равен right,
  // NOTCH_WIDTH везде совпадает с полной шириной — монтажёрские плашки
  // спокойно занимают этот угол.
  rightCornerLeft: 1036,
  rightCornerTop: 1150,
  rightCornerBottom: 1680,
  // Нижний левый блок: x=64-836, y=1540-1680
  bottomLeftRight: 836,   // ← Изменено с 868 до 836
  bottomLeftTop: 1540,
  bottomLeftBottom: 1680,
};

// Координаты логотипа (от левого верхнего угла: X=64px, Y=272px)
export const LOGO_BOUNDS = {
  x: 64,
  y: 272,
  width: 240,
  height: 240,
};

export const DEFAULT_LOGO_SIZE = 240;

// Адаптивный размер шрифта на основе длины текста
export function getAdaptiveFontSize(textLength: number): number {
  if (textLength < 20) return 24;
  if (textLength < 50) return 20;
  if (textLength < 100) return 18;
  return 16;
}

// Масштабирование границ
export function scaleBounds(bounds: typeof TEMPLATE_BOUNDS, scale: number) {
  return {
    left: bounds.left * scale,
    right: bounds.right * scale,
    top: bounds.top * scale,
    bottom: bounds.bottom * scale,
    rightCornerLeft: bounds.rightCornerLeft * scale,
    rightCornerTop: bounds.rightCornerTop * scale,
    rightCornerBottom: bounds.rightCornerBottom * scale,
    bottomLeftRight: bounds.bottomLeftRight * scale,
    bottomLeftTop: bounds.bottomLeftTop * scale,
    bottomLeftBottom: bounds.bottomLeftBottom * scale,
  };
}
